
// import Vue from 'vue'
// import _ from 'lodash'
// import { i18n } from '@/i18n'

const state = () => {
  return {
    selectedClient: -1,
    selectedClientName: null,
    unableDashboard: false,
  }
}

const getters = {
  getSelectedClient: state => state.selectedClient,
  getSelectedClientName: state => state.selectedClientName,
  getUnableDashboard: state => state.unableDashboard,
}

const mutations = {
  setSelectedClient (state, selectedClient) {
    state.selectedClient = selectedClient
  },
  setSelectedClientName (state, selectedClientName) {
    state.selectedClientName = selectedClientName
  },
  setUnableDashboard (state, unableDashboard) {
    state.unableDashboard = unableDashboard
  },
}

const actions = {
  setSelectedClient ({ commit }, data) {
    commit('setSelectedClient', data)
  },
  setSelectedClientName ({ commit }, data) {
    commit('setSelectedClientName', data)
  },
  setUnableDashboard ({ commit }, data) {
    commit('setUnableDashboard', data)
  },
}



export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
